(function(){
  async function init_see_what_our_customers_are_saying(){
    await MB_waitElementReady(".see_what_our_customers_are_saying .flickityt4s-viewport .t4s-col-item")
    await MB_sleep(100)
    $(".see_what_our_customers_are_saying .t4s-col-item").each(function(i){
      $(this).each(function(e){
        $(this).css('height','100%')
      })
    })

  }
  document.addEventListener('DOMContentLoaded', function(){
    // console.log("DOMContentLoaded")
    MB_jsDeferHandle(init_see_what_our_customers_are_saying, ['jQuery'])
  })
}())